export default __webpack_public_path__ + "static/media/natures_way.d31af293.svg";